import { useCallback, useState } from 'react';
import { SubscriptionRequest } from 'services/subscription/types';
import { createSubscription } from 'services/subscription/subscriptionService';
import { resolveRecurrence } from 'services/payment/rules';
import { REACT_APP_RULE_OMIT_PAYMENT_COUNTRY_EXCEPTION } from 'config';

interface UseStripeHandlerOptions {
  language: string;
  objectData: any;
  region: string;
  isLoaded: boolean;
  result: any;
  onError: (type: string) => void;
  setStatus: (status: string) => void;
  setSuccess: (success: boolean) => void;
  handleStripeResponse: (dato: any, sessionToken: string) => void;
}

export function useStripeHandler(language:string, objectData:any, region:string, onError: (type:string) => void, setStatus: (status:string) => void, setSuccess: (success:boolean) => void) : UseStripeHandlerOptions {
  const [result, setResult] = useState<any>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleStripeResponse = useCallback(async (dato: any, sessionToken: string) => {
    console.log('stripe', dato);
    setIsLoaded(true);
    if (!dato) {
      setIsLoaded(false);
      onError('payment');
      return;
    }

    if (dato?.error) {
      setIsLoaded(false);
      onError('payment');
      console.error('subscription', dato?.error);
      return;
    }

    setResult(dato);
    setSuccess(true);
    setStatus(dato.status);

    //if (['card', 'credit_card', 'recurring'].includes(dato.args.paymentMethod)) {
      let recurrentOption = resolveRecurrence({
        market: region,
        country: objectData.country || '',
        frequency: objectData.frequency,
        automaticApproval: objectData.automaticApproval,
        userAuthorized: Boolean(objectData.recurrent),
        countryException: REACT_APP_RULE_OMIT_PAYMENT_COUNTRY_EXCEPTION,
        isFirstPaymentScreen: true,
      }).recurrent;
      if (dato.payment_method) recurrentOption = true;

      const subscriptionData: SubscriptionRequest = {
        reference: dato.id,
        //sig: dato.args.sig,
        status: dato.status === 'succeeded' ? 'success' : 'pending',
        payerAmount: dato.amount,
        payerAmountCurrency: dato.currency,
        amount: dato.amount === undefined ? dato.amount : String(dato.amount),
        amountCurrency: dato.currency,
        paymentMethod: dato.payment_method_types[0] || 'card',
        subscription: {
          id_quotation: objectData.idQuotation,
          id_application: objectData.idApplication,
          recurrent: recurrentOption,
          paymaster: objectData.payingForPolicy,
          paymaster_relationship: objectData.payingForPolicy === 'Other' ? objectData.relationship : objectData.payingForPolicy,
        },
        payer: {
          first_name: objectData.firstName,
          last_name: objectData.lastName,
          middle_name: objectData.middleName,
          address1: objectData.address,
          address2: '',
          city: objectData.cityForFlywire || objectData.city,
          state: objectData.state,
          zip: objectData.zipCode,
          country: objectData.country,
          phone: objectData.phone,
          email: objectData.email,
          paymaster: objectData.payingForPolicy,
          paymaster_relationship: objectData.relationship,
        }
      };

      //if (['credit', 'debit'].includes(dato.args.type)) {
        subscriptionData.card = {
          token: dato.payment_method,
        };
      //}

      const res = await createSubscription(subscriptionData, sessionToken, objectData.country, region, 'STP');
      if (!res.success) {
        console.error('subscription(response)', res.error);
      } else {
        console.log('subscription(response)', res.data);
      }
      setIsLoaded(false);
    //} else {
      //console.warn('subscription', 'Payment method not supported');
    //}
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectData, onError]);

  return { language, objectData, region, isLoaded, result, handleStripeResponse, setStatus, setSuccess, onError };
}